"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.datesAsText = datesAsText;
exports.languageAsText = languageAsText;
exports.presentCV = presentCV;
exports.skillAsText = skillAsText;
exports.typesOfRole = void 0;
var _rdflib = require("rdflib");
var _solidUi = require("solid-ui");
const ORG = (0, _rdflib.Namespace)('http://www.w3.org/ns/org#');
const typesOfRole = exports.typesOfRole = ['PastRole', 'CurrentRole', 'FutureRole'];
function skillAsText(store, sk) {
  if (sk.termType === 'Literal') return sk.value; // Not normal but allow this
  const publicId = store.anyJS(sk, _solidUi.ns.solid('publicId'));
  if (publicId) {
    const name = store.anyJS(publicId, _solidUi.ns.schema('name'));
    if (name) return name; // @@ check language and get name in diff language if necessary
  }
  const manual = store.anyJS(sk, _solidUi.ns.vcard('role'));
  if (manual && manual[0] > '') return manual;
  return '';
}
function languageAsText(store, lan) {
  if (lan.termType === 'Literal') return lan.value; // Not normal but allow this
  const publicId = store.anyJS(lan, _solidUi.ns.solid('publicId'));
  if (publicId) return _solidUi.utils.label(publicId, true); // @@ check language and get name in diff language if necessary
  return '';
}
function datesAsText(startDate, endDate) {
  return startDate ? '(' + startDate.value.slice(0, 10) + ' to ' + (endDate ? endDate.value.slice(0, 10) : '') + ')' : '';
}
function expandRdfList(store, node) {
  const collectionElements = node.elements;
  if (Array.isArray(collectionElements)) {
    return collectionElements.flatMap(element => expandRdfList(store, element));
  }
  const first = store.any(node, _solidUi.ns.rdf('first'));
  if (!first) return [node];
  const items = [];
  let current = node;
  while (current) {
    const value = store.any(current, _solidUi.ns.rdf('first'));
    if (value) items.push(...expandRdfList(store, value));
    const rest = store.any(current, _solidUi.ns.rdf('rest'));
    if (!rest || rest.termType === 'NamedNode' && rest.value === _solidUi.ns.rdf('nil').value) break;
    current = rest;
  }
  return items;
}
function getRolesByType(store, subject) {
  const memberships = store.each(null, ORG('member'), subject, null);
  const rolesByType = {
    PastRole: [],
    CurrentRole: [],
    FutureRole: []
  };
  for (const membership of memberships) {
    let orgHomePage, orgNameGiven, publicIdName, roleName, publicId;
    // Things should have start dates but we will be very lenient in this view
    const startDate = store.any(membership, _solidUi.ns.schema('startDate'));
    const endDate = store.any(membership, _solidUi.ns.schema('endDate'));
    const dates = datesAsText(startDate, endDate);
    const organization = store.any(membership, ORG('organization'));
    if (organization) {
      orgNameGiven = store.anyJS(organization, _solidUi.ns.schema('name'));
      orgHomePage = store.any(organization, _solidUi.ns.schema('uri'));
      publicId = store.any(organization, _solidUi.ns.solid('publicId'));
    }
    if (publicId) {
      publicIdName = store.anyJS(publicId, _solidUi.ns.schema('name'));
    }
    const orgName = publicIdName || orgNameGiven;
    const escoRole = store.any(membership, ORG('role'));
    if (escoRole) {
      roleName = store.anyJS(escoRole, _solidUi.ns.schema('name'));
    }
    const roleText0 = store.anyJS(membership, _solidUi.ns.vcard('role'));
    const roleText = roleText0 && roleName ? roleName + ' - ' + roleText0 : roleText0 || roleName;
    const item = {
      startDate: startDate,
      endDate,
      orgName,
      roleText,
      dates,
      orgHomePage
    };
    for (const t of typesOfRole) {
      if (store.holds(membership, _solidUi.ns.rdf('type'), _solidUi.ns.solid(t))) {
        rolesByType[t].push(item);
      }
    }
  }
  return rolesByType;
}
function presentCV(subject, store) {
  const rolesByType = getRolesByType(store, subject);
  // Most recent thing most relevant -> sort by end date
  for (const t of typesOfRole) {
    rolesByType[t].sort(function (x, y) {
      if (x.endDate && y.endDate) {
        return x.endDate > y.endDate ? -1 : 1;
      }
      return x.startDate > y.startDate ? -1 : 1;
    });
  }
  const skills = store.each(subject, _solidUi.ns.schema('skills')).map(sk => skillAsText(store, sk)).filter(skill => skill !== '');
  const languageNodes = store.each(subject, _solidUi.ns.schema('knowsLanguage'));
  const languages = languageNodes.flatMap(node => expandRdfList(store, node)).map(lan => languageAsText(store, lan));
  // Deduplicate languages
  const uniqueLanguages = Array.from(new Set(languages));
  return {
    rolesByType,
    skills,
    languages: uniqueLanguages
  };
}